<template>
  <div>
    <div class="sixteentosix omt-6 omt-md-25 otp-screen-wrap">
      <div
        class="kachelimage header-image"
        style="background: url('/static/img/header_homepage.jpg')"
      >
        <div class="otp-white-wrapper">
          <h2 class="otp-head">{{ $t("otpVerification") }}</h2>
          <p class="inner-form-head" v-if="!feedback">
            {{ $t("oneTimePassword") }} <br />{{ $t("toDownload") }}
          </p>
          <p class="inner-form-head" v-if="feedback">
            {{ $t("oneTimePassword") }}
          </p>
          <p class="inner-form-info">{{ $t("sixDigitOtp") }}</p>
          <div class="opt-form-wrap">
            <v-text-field
              hide-details="auto"
              class="otp-input"
              dense
              outlined
              :label="$t('enter_password')"
              v-model="otp"
            ></v-text-field>
            <v-btn
              outlined
              depressed
              tile
              class="savebutton"
              @click="verifyOtp()"
              >{{ $t("continue") }}
              <v-icon>fa-solid fa-caret-right</v-icon></v-btn
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      bookingId: null,
      trainingId: null,
      trainingEventId: null,
      otp: null,
    };
  },
  mounted() {
    this.bookingId = this.$route.query.bookingId;
    this.trainingId = this.$route.query.trainingId;
    this.documentChange = this.$route.query.documentChange;
    this.trainingEventId = this.$route.query.trainingEventId;
    this.feedback = this.$route.query.feedback;
  },
  methods: {
    onError(err) {
      if (err.response != null && err.response.data != null) {
        this.$noty.error(err.response.data);
      } else {
        console.error(err);
      }
    },
    verifyOtp() {
      var _this = this;
      _this.otp = _this.otp.trim();
      if (_this.otp && /^\d+$/.test(_this.otp)) {
        let bookingId = parseInt(_this.bookingId);
        let trainingId = parseInt(_this.trainingId);
        let documentChange = _this.documentChange;
        if (_this.trainingId == "null") {
          trainingId = 0;
        }
        let otp = parseInt(_this.otp);
        let trainingEventId = parseInt(_this.trainingEventId);
        if (this.$route.query.feedback === "true") {
          this.$axios
            .get(
              "/api/booking/feedbackOtpVerification/" +
                bookingId +
                "/" +
                trainingEventId +
                "/" +
                otp
            )
            .then(function (response) {
              _this.$router.push(
                "/feedback-form?bookingId=" +
                  bookingId +
                  "&trainingEventId=" +
                  trainingEventId
              );
            })
            .catch(this.onError);
        } else {
          this.$axios
            .get(
              "/api/booking/otpVerification/" +
                bookingId +
                "/" +
                trainingId +
                "/" +
                otp
            )
            .then(function (response) {
              if (!documentChange) {
                _this.$router.push(
                  "/download-documents?trainingId=" +
                    trainingId +
                    "&bookingId=" +
                    _this.bookingId +
                    "&eventId=" +
                    trainingEventId +
                    "&otp=" +
                    _this.otp
                );
                // window.location.href =
                //   "/download-documents?trainingId=" +
                //   trainingId +
                //   "&bookingId=" +
                //   _this.bookingId +
                //   "&eventId=" +
                //   trainingEventId +
                //   "&otp=" +
                //   _this.otp;
              } else {
                _this.$router.push(
                  "/download-documents?trainingId=" +
                    trainingId +
                    "&bookingId=" +
                    _this.bookingId +
                    "&eventId=" +
                    trainingEventId +
                    "&otp=" +
                    _this.otp +
                    "&documentChange=" +
                    documentChange
                );
                // window.location.href =
                //   "/download-documents?trainingId=" +
                //   trainingId +
                //   "&bookingId=" +
                //   _this.bookingId +
                //   "&eventId=" +
                //   trainingEventId +
                //   "&otp=" +
                //   _this.otp +
                //   "&documentChange=" +
                //   documentChange;
              }
            })
            .catch(this.onError);
        }
      } else {
        // OTP value is either empty or invalid
        this.$noty.error(this.$t("invalid_otp"));
        return;
      }
    },
  },
};
</script>
